angular.module('picmonicng').component('homeWebinars', {
  templateUrl: '/templates/app/components/home-webinars/home-webinars.html',
  bindings: {},
  controller: [
    'UserService',
    'WebinarsService',
    'WebinarResource',
    function (UserService, WebinarsService, WebinarResource) {
      var ctrl = this;
      ctrl.learnMore = false;
      ctrl.WebinarsService = WebinarsService;

      WebinarResource.get({ webinar_id: 'all', market_id: UserService.user.lead }, function (webinars) {
        if (webinars.live.length) {
          webinars.live = WebinarsService.process(webinars.live);
        }

        ctrl.webinars = webinars;
      });

      ctrl.toggleLearnMore = function () {
        ctrl.learnMore = !ctrl.learnMore;
      };
    },
  ],
});
